import React from 'react';
import { Box, Typography, Button, IconButton, Tooltip } from '@material-ui/core';
import {
  ErrorOutline as ErrorOutlineIcon,
  Warning as WarningIcon,
  TrendingUp as TrendingUpIcon,
  Stars as StarsIcon,
  Close as CloseIcon,
  VisibilityOff as VisibilityOffIcon,
  ArrowForward as ArrowForwardIcon,
} from '@material-ui/icons';

const getSeverityIcon = (severity, category) => {
  if (category === 'celebration') {
    return <TrendingUpIcon style={{ fontSize: '0.9rem', color: '#15803d' }} />;
  }
  if (category === 'activation') {
    return <StarsIcon style={{ fontSize: '0.9rem', color: '#0284c7' }} />;
  }
  if (severity === 'Crítica' || severity === 'Alta') {
    return <ErrorOutlineIcon style={{ fontSize: '0.9rem', color: '#dc2626' }} />;
  }
  return <WarningIcon style={{ fontSize: '0.9rem', color: '#b45309' }} />;
};

const getBadgeLabel = (severity, category) => {
  if (category === 'celebration') return 'Celebração';
  if (category === 'activation') return 'Sugestão';
  if (severity === 'Crítica') return 'Crítico';
  if (severity === 'Alta') return 'Urgente';
  return 'Atenção';
};

const getCardModifierClass = (severity, category) => {
  if (category === 'celebration') return 'duxia-insight-card--celebration';
  if (category === 'activation') return 'duxia-insight-card--activation';
  if (severity === 'Crítica' || severity === 'Alta') return 'duxia-insight-card--alta';
  return 'duxia-insight-card--media';
};

const getBadgeModifierClass = (severity, category) => {
  if (category === 'celebration') return 'duxia-insight-badge--celebration';
  if (category === 'activation') return 'duxia-insight-badge--activation';
  if (severity === 'Crítica' || severity === 'Alta') return 'duxia-insight-badge--alta';
  return 'duxia-insight-badge--media';
};

const getCtaModifierClass = (severity, category) => {
  if (category === 'celebration') return 'duxia-insight-card__cta--celebration';
  if (category === 'activation') return 'duxia-insight-card__cta--activation';
  if (severity === 'Crítica' || severity === 'Alta') return 'duxia-insight-card__cta--alta';
  return 'duxia-insight-card__cta--media';
};

const getPersonaLabel = (cta) => {
  if (cta?.action_type === 'NAVIGATE') {
    return '📊 Relatório';
  }
  if (cta?.specialist === 'stock') {
    return '📦 duxIA Estoque';
  }
  if (cta?.specialist === 'financial') {
    return '💰 duxIA Finanças';
  }
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      <img
        src="/image/duxia.jpg"
        alt="duxIA"
        style={{ width: 14, height: 14, borderRadius: '50%', objectFit: 'cover' }}
      />
      duxIA Geral
    </span>
  );
};

const DuxiaInsightCard = ({ insight, onCta, onCtaClick, onDismiss }) => {
  if (!insight) return null;

  const handleAction = onCta || onCtaClick;
  const isActivation = insight.category === 'activation';
  const cardModifier = getCardModifierClass(insight.severity, insight.category);
  const badgeModifier = getBadgeModifierClass(insight.severity, insight.category);
  const ctaModifier = getCtaModifierClass(insight.severity, insight.category);

  return (
    <Box className={`duxia-insight-card ${cardModifier}`}>
      <Box className="duxia-insight-card__top">
        <Box className="duxia-insight-card__badge-row">
          <span className={`duxia-insight-badge ${badgeModifier}`}>
            {getSeverityIcon(insight.severity, insight.category)}
            {getBadgeLabel(insight.severity, insight.category)}
          </span>
        </Box>

        {isActivation ? (
          <Tooltip title="Dispensar sugestão (não exibir por 7 dias)">
            <IconButton
              size="small"
              aria-label="Dispensar sugestão"
              className="duxia-insight-card__dismiss duxia-insight-card__dismiss--activation"
              onClick={(e) => onDismiss && onDismiss(insight.id, 'activation', e)}
            >
              <CloseIcon style={{ fontSize: '0.95rem' }} />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Ocultar este alerta por hoje (reaparecerá amanhã se persistir)">
            <IconButton
              size="small"
              aria-label="Ocultar alerta por hoje"
              className="duxia-insight-card__dismiss duxia-insight-card__dismiss--hide-today"
              onClick={(e) => onDismiss && onDismiss(insight.id, 'health', e)}
            >
              <VisibilityOffIcon style={{ fontSize: '0.95rem' }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      <Typography className="duxia-insight-card__body">
        {insight.message}
      </Typography>

      <Box className="duxia-insight-card__bottom">
        <Button
          variant="contained"
          size="small"
          className={`duxia-insight-card__cta ${ctaModifier}`}
          onClick={() => handleAction && handleAction(insight)}
          endIcon={<ArrowForwardIcon style={{ fontSize: '0.85rem' }} />}
        >
          {insight.cta?.text || 'Abrir'}
        </Button>

        <span className="duxia-insight-persona-indicator">
          {getPersonaLabel(insight.cta)}
        </span>
      </Box>
    </Box>
  );
};

export default DuxiaInsightCard;
